function getBrPageContent(page, reference) {
    var ref;
    if (!page) {
        return undefined;
    }
    if (!reference) {
        return undefined;
    }
    return (ref = page.getContent(reference)) === null || ref === void 0 ? void 0 : ref.getData();
}

export { getBrPageContent };
//# sourceMappingURL=get-br-page-content.js.map
